import EaFeaturedIcon1 from '@propertypal/shared/src/resources/icons/premier-listing/ea-featured-icon1.svg';
import EaFeaturedIcon2 from '@propertypal/shared/src/resources/icons/premier-listing/ea-featured-icon2.svg';
import EaFeaturedIcon3 from '@propertypal/shared/src/resources/icons/premier-listing/ea-featured-icon3.svg';
import PnFeaturedIcon1 from '@propertypal/shared/src/resources/icons/premier-listing/pn-premier-icon1.svg';
import PnFeaturedIcon2 from '@propertypal/shared/src/resources/icons/premier-listing/pn-premier-icon2.svg';
import PnFeaturedIcon3 from '@propertypal/shared/src/resources/icons/premier-listing/pn-premier-icon3.svg';
import FeaturedFeatureMockup from '@propertypal/shared/src/resources/images/promote/featured-iPhone.png';
import FeaturedMockup from '@propertypal/shared/src/resources/images/promote/featured-macbook.png';
import PnFeatureMobMockup from '@propertypal/shared/src/resources/images/promote/pn-featured-mob-mockup.png';
import PnFeaturedMockup from '@propertypal/shared/src/resources/images/promote/pn-featured-mockup.png';
import { Property } from '@propertypal/shared/src/types';
import platform from '@propertypal/shared/src/utils/platform';
import PromoteHeader from '@propertypal/web-ui/src/headers/promote/PromoteHeader';
import PromoteFeatures, { PromoteFeaturesIcon } from '@propertypal/web-ui/src/promote/PromoteFeatures';
import PromoteSuperfeature from '@propertypal/web-ui/src/promote/PromoteSuperfeature';
import PromoteTable from '@propertypal/web-ui/src/promote/PromoteTable';
import React, { useMemo } from 'react';
import { BookButton, CanBook } from './PremierBookButton';

const icons: PromoteFeaturesIcon[] = [
  {
    SVG: platform.select(EaFeaturedIcon1, PnFeaturedIcon1),
    heading: 'Enhanced',
    text: 'listing with additional photos for your selected area.',
    maxW: 305,
  },
  {
    SVG: platform.select(EaFeaturedIcon2, PnFeaturedIcon2),
    heading: '3 times',
    text: 'more clicks to your property details page.',
    maxW: 260,
  },
  {
    SVG: platform.select(EaFeaturedIcon3, PnFeaturedIcon3),
    heading: '1.5 times',
    text: 'more enquiries than a standard listing',
    maxW: 200,
  },
];

interface FeaturedListingContentProps {
  products?: boolean;
  property?: Property | null;
}

const FeaturedListingContent: React.FC<FeaturedListingContentProps> = ({ products, property }) => {
  const { canBook, button }: { canBook: CanBook; button: BookButton } = useMemo(() => {
    return {
      canBook: {
        available: true,
        availableTimePeriod: null,
        title: ``,
      },
      button: {
        href: `${platform.ordersUrl}/feature-property${property ? `/${property.id}` : ''}`,
        text: 'Book a Featured Listing',
      },
    };
  }, [property]);

  return (
    <>
      <PromoteHeader products={products} propertyId={property?.pathId} />
      <PromoteSuperfeature
        title="Featured Listing"
        mockup={{
          src: platform.select(FeaturedMockup.src, PnFeaturedMockup.src),
          alt: 'Featured Listing',
          aspectRatio: '1430/863',
        }}
        badge={{
          title: 'From £48',
          text: 'depending on search terms & duration for a sales property',
          textMw: 160,
          mobTextMw: 120,
          subtext: '*£24 for a rental property',
          size: 190,
          titleMt: 5,
          mobSize: 150,
        }}
        button={button}
        features={[
          [],
          [
            {
              title: 'Increase Exposure',
              text: 'Ensure your property stands out by appearing at the top of search results.',
            },
            {
              title: 'Target Specific Areas',
              text: 'Choose the exact location you want to target and stay visible in that area for as long as you need.',
            },
          ],
        ]}
        canBook={canBook}
        pb={!canBook?.available ? 60 : undefined}
      />
      <PromoteFeatures
        icons={icons}
        iconsMw={1170}
        mockup={{
          src: platform.select(FeaturedFeatureMockup.src, PnFeatureMobMockup.src),
          alt: 'Featured Listing',
          maxW: 295,
        }}
        featureTitle="Featured Listing Advantages:"
        features={[
          `Boost your property's visibility by ranking higher in our search results.`,
          `Reach active buyers and renters as they browse listings.`,
          `Promote your property in multiple locations.`,
          `Stay at the top of the search results for your chosen locations.`,
          `Get 1.5 times more views than standard listings.`,
          // eslint-disable-next-line max-len
          `Maximum reach on the two most popular property portals in Northern Ireland, ensuring your property is seen by the largest possible audience.`,
        ]}
        button={button}
        canBook={canBook?.available}
      />
      <PromoteTable highlightIndex={2} property={property} />
    </>
  );
};

export default FeaturedListingContent;
